import { Injectable, Inject } from '@angular/core';

import { FsMapRegistryCamerasServiceProvider, IFsMap } from '@lib/geo/core';

@Injectable()
export class MapRegistryCamerasFacadeService<
  TMap extends IFsMap = IFsMap,
> extends FsMapRegistryCamerasServiceProvider<TMap> {
  constructor(
    @Inject(FsMapRegistryCamerasServiceProvider)
    private readonly provider: FsMapRegistryCamerasServiceProvider<TMap>,
  ) {
    super();
  }

  public get isAvailable(): boolean {
    return this.provider.isAvailable;
  }

  public onMapLoaded(map: TMap): void {
    this.provider.onMapLoaded(map);
  }

  public addToMap(): void {
    this.provider.addToMap();
  }

  public removeFromMap(): void {
    this.provider.removeFromMap();
  }
}
